import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_24HrCrisisAndEmergencyAfterHr = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_24HrCrisisAndEmergencyAfterHr' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <b>24-Hour Crisis/Emergency Availability After Hours/Crisis Number: &nbsp;</b>
                    <input type="text" name="txtEmergency" id="txtEmergency" className='add-only w-250 custom-add-only' />
                </p>
                <p className='w-750'>
                    <b>POLICY:</b> Client will receive crisis-related services as needed, including during non-regular scheduled office hours and on weekends. Agency staff on weekly rotating basis will render crisis services.
                </p>
                <p className='w-750'>
                    <b>PURPOSE:</b> To ensure that emergency needs of clients are addressed in a timely manner.
                </p>
                <p className='w-750'>
                    <b>PROCEDURE:</b>
                </p>

                <p className='w-750'>
                    <ul>
                        <li>All direct services staff and the clinical supervisors will participate in a staff rotating system to provide on-call crisis services. Staff will be on call for one week at a time.</li>
                        <li>The rotating system will run alphabetically (A-Z) of each staff member.</li>
                        <li>The staff member on-call will obtain the agency cell phone from the office manage no later than 4:00 p.m. of on-call status.</li>
                        <li>Clients will activate the crisis system by calling the after-hour listed number on this form and client handbook.</li>
                        <li>Upon receiving the call from the client in crisis, the on-call will respond within 30 minutes, unless a more immediate response is possible.</li>
                        <li>The on call-staff member's role is to assess the nature of the current status and obtain important information from caller.</li>
                        <li>Based upon the assessment and the judgement of the on-call he/she may:

                            <ul>
                                <li>Handle the crisis over the phone if possible.</li>
                                <li>Arrange for psychiatric services and possible hospitalization and/or direct contact to a psychiatric facility with which the agency has a prearranged relationship.</li>
                            </ul>

                        </li>
                    </ul>
                </p>

                <p className='w-750'>
                    All crisis calls must be recorded in the Crisis Phone Log, which must be handed in to the Clinical Supervisor at the end the worker's on-call status. If the on-call worker had difficulty in implementing the policy of determining proper action regarding a client in crisis, the on-call worker must contact the Clinical Supervisor.
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Client Signature</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Legal Guardian/Parent Signature</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Service Coordinator Signature</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











